<template>
  <div class="map-list-dialog ai-dialog">
    <div class="map-list-dialog-content">
      <div class="map-list-dialog-content-button">
        <div class="map-list-dialog-content-button-left">
          <p @click="closeMapListDialog">取消</p>
          <slot name="button"></slot>
        </div>
        <el-input
          placeholder="请输入内容"
          class="search"
          @keyup.enter.native="search"
          v-model="inputSearch">
        </el-input>
      </div>
      <slot name="list"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputSearch: ''
    };
  },
  methods: {
    closeMapListDialog() {
      this.$emit('closeMapListDialog');
    },
    // 搜索
    search() {
      this.$emit('search', this.inputSearch);
      console.log('search')
    }
  }
};
</script>

<style scoped lang="scss">
  .map-list-dialog {
    background: rgba(0, 0, 0, 0.5);
    pointer-events: auto;

    .map-list-dialog-content {
      width: 740px;
      height: 540px;
      padding: 30px;
      background-color: #393939;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.20);
      border-radius: 10px;
      z-index: 1001;

      .map-list-dialog-content-button {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .map-list-dialog-content-button-left {
          display: flex;

          p {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 16px;
            color: #ADADAD;
            border: 1px solid #ADADAD;
            border-radius: 4px;
            margin: 0;
          }

          .affirm {
            color: #08CE82;
            border: 1px solid #08CE82;
            margin-left: 20px;
          }
        }
        /deep/input.el-input__inner{
          color: #fff;
        }
      }

      .map-list-dialog-content-table {
        border-top: 1px solid #ADADAD;
        margin-top: 30px;
        height: 482px;
        overflow-y: scroll;

        li {
          height: 36px;
          line-height: 36px;
          list-style: none;
          color: #ffffff;
          font-size: 16px;
          border-bottom: 1px solid #ADADAD;
          display: flex;

          p {
            margin: 0;
          }

          /deep/ .el-checkbox__input {
            width: 16px;
            height: 16px;
          }

          /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
            background: #08CE82;
          }

          /deep/ .el-checkbox__inner::after {
            height: 5px;
            top: 2px;
          }
        }

        .disabled {
          /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
            background: #ADADAD;
          }

          color: #ADADAD!important;
        }

        .checked {
          color: #08CE82;
        }

        &--address {
          width: 50%;
          /*height: 50%;*/
          overflow: hidden;
        }
      }
    }
  }
</style>
